import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Settings, X } from 'lucide-react';
interface SettingsMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SettingsMenu({
  isOpen,
  onClose
}: SettingsMenuProps) {
  const [graphicsQuality, setGraphicsQuality] = useState(100);
  return <AnimatePresence data-id="element-694">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/50 z-[60]" data-id="element-695" />

          {/* Menu Panel */}
          <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} className="fixed top-20 right-6 z-[70] bg-slate-800/95 backdrop-blur-xl rounded-xl border border-white/10 shadow-2xl p-6 min-w-[320px]" data-id="element-696">
            {/* Header */}
            <div className="flex items-center justify-between mb-6" data-id="element-697">
              <div className="flex items-center gap-2" data-id="element-698">
                <Settings className="w-5 h-5 text-white/70" data-id="element-699" />
                <h3 className="text-white font-medium" data-id="element-700">Settings</h3>
              </div>
              <button onClick={onClose} className="p-1 rounded-lg hover:bg-white/10 transition-colors" data-id="element-701">
                <X className="w-5 h-5 text-white/70" data-id="element-702" />
              </button>
            </div>

            {/* Graphics Resolution */}
            <div className="space-y-3" data-id="element-703">
              <label className="text-white/70 text-sm" data-id="element-704">
                Graphics Resolution
              </label>
              <div className="flex items-center gap-3" data-id="element-705">
                <input type="range" min="0" max="100" value={graphicsQuality} onChange={e => setGraphicsQuality(Number(e.target.value))} className="flex-1 h-2 bg-slate-700 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-cyan-500" data-id="element-706" />
                <span className="text-cyan-500 font-medium text-sm w-12 text-right" data-id="element-707">
                  {graphicsQuality}%
                </span>
              </div>
              <div className="flex items-center justify-between text-xs text-white/50" data-id="element-708">
                <span data-id="element-709">Low</span>
                <span data-id="element-710">Cinematic</span>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}